export const city = {
  state: {
    type: 'tabs',
    name: 'city',
    value: null,
    inputs: [],
    boundInputs: [
      {
        name: '',
        inputMap: {},
      },
    ],
    header: 'Город',
  },
};
